import useMutation from "src/hooks/useMutation";

function useUserReset(id) {
  return useMutation({
    path: `/api/v1/users/${id}/reset-password`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/users/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useUserReset;
